import React from 'react';
import { ArrowLeft, Clock, Hourglass, AlertTriangle } from 'lucide-react';
import { InventoryCard } from '../components/InventoryCard';
import { useInventory, InventoryItem } from '../hooks/useInventory';
interface ExpiringItemsProps {
  onBack: () => void;
  onItemClick: (item: InventoryItem) => void;
}
export function ExpiringItems({
  onBack,
  onItemClick
}: ExpiringItemsProps) {
  const {
    getExpiringSoon
  } = useInventory();
  const expiringItems = getExpiringSoon();
  return <div className="pb-24 max-w-md mx-auto p-4 min-h-screen" data-id="element-207">
      <div className="flex items-center mb-6" data-id="element-208">
        <button onClick={onBack} className="mr-3 p-2 hover:bg-[#C9A227]/20 rounded-full transition-colors" data-id="element-209">
          <ArrowLeft className="w-5 h-5 text-[#722F37]" data-id="element-210" />
        </button>
        <div data-id="element-211">
          <h1 className="text-xl font-cinzel font-bold text-[#2C2C2C]" data-id="element-212">
            Tempus Warnings
          </h1>
          <p className="text-sm text-[#722F37] font-serif italic" data-id="element-213">
            Time is of the essence
          </p>
        </div>
      </div>

      {expiringItems.length === 0 ? <div className="flex flex-col items-center justify-center py-20 text-center" data-id="element-214">
          <div className="w-20 h-20 bg-[#F5F0E1] border-2 border-[#2D5A3D] rounded-full flex items-center justify-center mb-4 shadow-[0_0_15px_rgba(45,90,61,0.2)]" data-id="element-215">
            <Hourglass className="w-10 h-10 text-[#2D5A3D]" data-id="element-216" />
          </div>
          <h2 className="text-xl font-cinzel font-bold text-[#2C2C2C]" data-id="element-217">
            All Fresh!
          </h2>
          <p className="text-[#722F37] mt-2 font-serif italic" data-id="element-218">
            No items are nearing expiration
          </p>
        </div> : <div className="space-y-6" data-id="element-219">
          <div className="bg-[#FFFDF5] border-l-4 border-[#8B0000] rounded-r-xl p-4 flex items-start gap-4 shadow-sm" data-id="element-220">
            <div className="p-2 bg-[#8B0000]/10 rounded-full shrink-0" data-id="element-221">
              <Clock className="w-6 h-6 text-[#8B0000]" data-id="element-222" />
            </div>
            <div data-id="element-223">
              <h3 className="font-cinzel font-bold text-[#8B0000] text-base" data-id="element-224">
                {expiringItems.length} items expiring
              </h3>
              <p className="text-xs text-[#2C2C2C] mt-1 font-serif leading-relaxed" data-id="element-225">
                These provisions require immediate attention. Use them before
                they spoil.
              </p>
            </div>
          </div>

          <div className="space-y-3" data-id="element-226">
            {expiringItems.map(item => <InventoryCard key={item.id} item={item} onClick={() => onItemClick(item)} data-id="element-227" />)}
          </div>
        </div>}
    </div>;
}